import Integral from '../service/integral'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 积分规则
    getrulelist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.getrulelist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    closerule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.closerule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    openrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.openrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.getrule(payload), {
        type: 'info',
        success,
        fail
      })
    },
    adddailycheckin(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.adddailycheckin(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatedailycheckin(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.updatedailycheckin(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatepointstask(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.updatepointstask(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getpointstask(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.getpointstask(payload), {
        type: 'info',
        success,
        fail
      })
    },
    // 扫码
    updatescanccodepointsrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.updatescanccodepointsrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addscanccodepointsrules(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.addscanccodepointsrules(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletescanccodepointsrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.deletescanccodepointsrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getnoscanccodepointsruleproductnames(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(
        Integral.getnoscanccodepointsruleproductnames(payload),
        {
          type: 'list',
          success,
          fail
        }
      )
    },
    getscanccodepointsrules(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.getscanccodepointsrules(payload), {
        type: 'list',
        success,
        fail
      })
    },
    closescanccodepointsrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.closescanccodepointsrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    openscanccodepointsrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.openscanccodepointsrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    // 支付
    updatepayrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.updatepayrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addpayrules(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.addpayrules(payload), {
        type: 'action',
        success,
        fail
      })
    },
    delpayrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.delpayrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getnotsetedgoodslist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.getnotsetedgoodslist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getpayrules(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.getpayrules(payload), {
        type: 'list',
        success,
        fail
      })
    },
    closepayrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.closepayrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    openpayrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.openpayrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getofflineactivityrules(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.getofflineactivityrules(payload), {
        type: 'list',
        success,
        fail
      })
    },
    closeofflineactivityrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.closeofflineactivityrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    openofflineactivityrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.openofflineactivityrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getofflineactivityrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.getofflineactivityrule(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addofflineactivityrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.addofflineactivityrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateofflineactivityrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.updateofflineactivityrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deleteofflineactivityrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Integral.deleteofflineactivityrule(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
